# Controller = App.loadClass 'core::Angular/Controller'
IrrigationDetailsBase = App.loadClass 'grower::Angular/IrrigationDetailsBase'


# Handle the irrigation details step
class exports.IrrigationDetailsController extends IrrigationDetailsBase

    constructor: (@scope, @transitions, @transition$, @modalInstance, @service, @q, @ngModal) ->
        super(@scope, @transitions, @modalInstance)
        @scope.title = "Irrigation Details"
        @scope.validation = @validate
        @scope.copy = @copy
        @scope.copyDisabled = false
        @scope.save = @save

        @scope.details = {
            layers_management_zone_id: @transition$.params().layer_id,
            irrigation_method_id: null,
            energy_source: null,
            pump_pressure: null,
            pumping_depth: null,
            water_source_id: null,
            secondary_irrigation: false,
            secondary_use_pumps: null,
            secondary_energy_source: null,
            secondary_pump_pressure: null,
            secondary_pumping_depth: null,
        }

        @service.getMethods().then (response) =>
            @scope.irrigation_methods = response.data.data

        @service.getSources().then (response) =>
            @scope.energy_sources = response.data

        # load water sources (this could probably be a resolve)
        @service.getWaterSources().then (response) =>
            @scope.water_sources = response.data
            @scope.secondaryIrrigationWaterSourceId = @scope.water_sources.find((source) => return source.name is "Both Surface Water and Deep Aquifer Groundwater").id

        @service.load(@scope.details.layers_management_zone_id).then (response) =>
            @scope.details = response.data.data if response.data.data
            @setLoadedEnergySource()

    copy: () =>
        @scope.copyDisabled = true
        @service.save(@scope.details).then (response) =>
            @ngModal.openCopyIrrigationDetailsDialog(parseInt(@transition$.params().field_id), parseInt(@transition$.params().year), @scope.details)
                .modalRef.result
                .finally () => @scope.copyDisabled = false

        .catch (response) =>
            @scope.copyDisabled = false
            if response.status is 422
                return @q.reject(response)

    save: (pretending = false) =>
        @service.save(@scope.details).then (response) =>
            if not pretending
                @closeWithAlert({ type: 'success', msg: 'Irrigation details saved' }, @scope.details, 2000)

        .catch (response) =>
            if response.status is 422
                return @q.reject(response)
